import classNames from "classnames";
import React from "react";
interface Props {
  size?: number;
  color?: string;
  weight?: number;
  className?: string;
  align?: "center" | "left" | "right" | "justify";
  children: React.ReactNode;
  style?: any;
  tag?:
    | "span"
    | "small"
    | "p"
    | "strong"
    | "em"
    | "h1"
    | "h2"
    | "h3"
    | "h4"
    | "h5";
  refProp?: any;
}

export default function Text({
  size = 16,
  color = "#1B3F74",
  weight = 400,
  className,
  align = "left",
  children,
  tag = "span",
  style,
  refProp,
  ...props
}: Props) {
  const finalStyle = classNames("Text", className);
  return React.createElement(
    tag,
    {
      className: finalStyle,
      style: {
        fontWeight: weight,
        color: color,
        fontSize: `${size}px`,
        textAlign: align,
        ...style,
      },
      ...props,
      ref: refProp,
    },
    children
  );
}
